import React, { useEffect, useState } from "react";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Hero from "./components/sections/Hero";
import Showcase from "./components/sections/Showcase";
import Loop from "./components/sections/Loop";
import Why from "./components/sections/Why";
import Social from "./components/sections/Social";
import Faq from "./components/sections/Faq";
import Cta from "./components/sections/Cta";
import LookProvider from "./components/motion/LookProvider";

function App() {
  const searchParams = new URLSearchParams(document.location.search);
  const accountId = searchParams.get("accountId");
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!accountId || !process.env.REACT_APP_API_URL) {
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/${accountId}`
        );
        const jsonData = await response.json();
        if (jsonData && jsonData.status) {
          setData(jsonData.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [accountId]);

  return (
    <LookProvider>
      <div className="page-shell min-h-screen bg-canvas font-outfit text-ink">
        <Header data={data} />
        <main>
          <Hero />
          <Showcase />
          <Loop />
          <Why />
          <Social />
          <Faq />
          <Cta />
        </main>
        <Footer />
      </div>
    </LookProvider>
  );
}

export default App;
